import { render } from "./AddProductModal.vue?vue&type=template&id=eabef452"
import script from "./AddProductModal.vue?vue&type=script&lang=js"
export * from "./AddProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__